var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_iiqvnzs34njq 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-62",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3529 18.0526H17.0588V9.24887L10 2.1437L2.94118 9.24887V18.0526H7.64706V14.7369C7.64706 13.4314 8.70306 12.3685 10 12.3685C11.2969 12.3685 12.3529 13.4314 12.3529 14.7369V18.0526ZM17.5294 19H11.8824C11.6226 19 11.4118 18.7878 11.4118 18.5263V14.7369C11.4118 13.9534 10.7784 13.3159 10 13.3159C9.22165 13.3159 8.58824 13.9534 8.58824 14.7369V18.5263C8.58824 18.7878 8.37741 19 8.11765 19H2.47059C2.21082 19 2 18.7878 2 18.5263V9.05276C2 8.92676 2.04988 8.80645 2.13741 8.7174L9.66682 1.13855C9.85129 0.953816 10.1487 0.953816 10.3332 1.13855L17.8626 8.7174C17.9501 8.80645 18 8.92676 18 9.05276V18.5263C18 18.7878 17.7892 19 17.5294 19Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.247059
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.39c2f1d9c22506d4f18ed120d90a855b.svg";
export { ForwardRef as ReactComponent };